import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { upDirection, downDirection } from '../../../Common/constants';
import { setGridSortCriteria } from '../../actions';
import { getResolutionGridSortCriteria } from '../../selectors';

const useResolutionList = () => {
  const { sortByColumn, sortDirection } = useSelector(getResolutionGridSortCriteria);
  const dispatchGridSortCriteria = useAction(setGridSortCriteria);

  const handleColumnClick = ({ headerName, direction }) => {
    dispatchGridSortCriteria({
      sortByColumn: headerName,
      sortDirection: direction === upDirection ? downDirection : upDirection,
    });
  };

  return {
    handleColumnClick,
    sortByColumn,
    sortDirection,
  };
};

export default useResolutionList;
